import { createAsyncThunk } from "@reduxjs/toolkit";
import messagesService from "../../../api/services/messages";

export const createMessage = createAsyncThunk(
  "messages/create-message",
  async (requestData) => {
    return await messagesService.createMessage(requestData);
  }
);
